<aside class="snack-bar">
  <img class="snack-bar__icon" [src]="'assets/images/icons/' + type + '.svg'">

  <p class="snack-bar__paragraph" [innerHTML]="message"></p>

  <button (click)="closeSnackBar()" class="snack-bar__close">
    <div class="snack-bar__close--right"></div>
    <div class="snack-bar__close--left"></div>
  </button>
</aside>
